import type { ReactNode } from 'react';

import { Alert } from '@twilio-paste/core/alert';

import { DataGridEmptyState } from './DataGridEmptyState';

interface DataGridErrorStateProps {
  colSpan: number;
  children: NonNullable<ReactNode>;
}

export const DataGridErrorState = ({ colSpan, children }: DataGridErrorStateProps) => (
  <DataGridEmptyState colSpan={colSpan}>
    <Alert variant="error">{children}</Alert>
  </DataGridEmptyState>
);
